<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Product Database</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <div class="vx-col w-full mb-base">
        <vx-card>
          <vx-timeline :data="timelineData1"></vx-timeline>
          <vs-button type="flat" @click="downloadProducts" icon-pack="feather" icon="icon-download" class="mb-4">Download csv</vs-button>
          <vx-timeline :data="timelineData2"></vx-timeline>
          <file-pond
            name="files"
            ref="pond"
            label-idle="Drag and drop files here or click to upload"         
            allow-multiple="false"
            max-parallel-uploads="1"
            maxFileSize="5MB"
            pdfComponentExtraParams="toolbar=1&navpanes=1&view=fit&page=1"
            v-bind:acceptedFileTypes= "acceptedFileTypes"
            labelFileTypeNotAllowed="Invalid file format"
            labelMaxFileSize="Maximum file size is {filesize}"
            fileValidateTypeLabelExpectedTypes="Accepts csv only"
            v-bind:server="myServer"
            v-bind:files="myFiles"
            v-on:init="handleFilePondInit"
          />
        </vx-card>
    </div>
    

    <!-- <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <vs-upload action="https://jsonplaceholder.typicode.com/posts/" @on-success="successUpload" />

      </div>
    </VuePerfectScrollbar> -->

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VxTimeline from '@/app/shared/components/timeline/VxTimeline.vue'

import { api } from '@/app/shared/services';
import { apiConstants } from '../shared/config';

// Import FilePond
import vueFilePond from 'vue-filepond';

// Import plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';

// Import styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

// Create FilePond component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);


export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      }else {
        let { category, id, img, name, order_status, price } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataCategory = category
        this.dataImg = img
        this.dataName = name
        this.dataOrder_status = order_status
        this.dataPrice = price
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {

      dataId: null,
      dataName: "",
      dataCategory: null,
      dataImg: null,
      dataOrder_status: "pending",
      dataPrice: 0,

      category_choices: [
        {text:'Audio',value:'audio'},
        {text:'Computers',value:'computers'},
        {text:'Fitness',value:'fitness'},
        {text:'Appliance',value:'appliance'}
      ],

      order_status_choices: [
        {text:'Pending',value:'pending'},
        {text:'Canceled',value:'canceled'},
        {text:'Delivered',value:'delivered'},
        {text:'On Hold',value:'on_hold'}
      ],
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },

      timelineData1: [
        {
          color : 'primary',
          icon  : 'DownloadIcon',
          title : 'Download link database',
          desc  : 'List of links for each product available in the market ',
          time  : ''
        }
      ],
      timelineData2: [
        {
          color : 'warning',
          icon  : 'EditIcon',
          title : 'Update link database',
          desc  : 'Edit and Update the links in the downloaded sheet',
          time  : ''
        },
        {
          color : 'success',
          icon  : 'UploadIcon',
          title : 'Upload link database',
          desc  : 'Save and Upload the edited sheet as csv',
          time  : ''
        }
      ],

      acceptedFileTypes: ['text/csv'],
      // fake server to simulate loading a 'local' server file and processing a file
      myServer: {
        process: (fieldName, file, metadata, load, error) => {
          // simulates uploading a file
          const formData = new FormData();
          formData.append('template',file)
          // formData.append('category',this.$props.category)
          
          
          // this.$vs.loading({
          //   type: "radius",
          // }); 
          try{               
            api.post(apiConstants.upload, formData)
                .then((response) => {
                  load()
                  this.$vs.notify({time: 10000, color:'warning',title:'Product Link Update Process',text:'Product Link Update process is initiated. You will be notified once the update process is completed via email.'});
                })
                .catch((err) => {
                // this.$vs.loading.close();
                console.log(err);
                // error(getAxiosErrorMessage(err))
                    this.$vs.notify({
                      title: "Product Link Update Error",
                      text: "The file upload process is facing an error. Please contact the admin or try again later",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "danger",
                    });
              }) 
          } catch(e) {
            // this.$vs.loading.close();
          }
        },
        load: (source, load) => {
          // fetch(source).then(res => res.blob()).then(load);
          console.log(source, load);
        },
        remove: (source, load, error) => {
          // this.removeFile(source, load, error)
        },
        revert: (uniqueFileId, load, error) => {
          // this.removeFile(uniqueFileId, load, error)
        },
        restore: (uniqueFileId, load, error, progress, abort, headers) => {
          
        }
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.dataName && this.dataCategory && (this.dataPrice > 0)
    },
    myFiles(){
      return [];
    }
  },
  methods: {
    initValues() {
      if(this.data.id) return
        this.dataId = null
        this.dataName = ""
        this.dataCategory = null
        this.dataOrder_status = "pending"
        this.dataPrice = 0
        this.dataImg = null
    },
    downloadProducts() {
      this.$vs.loading({
        type: "radius",
      }); 
      try{ 
        console.log('apiConstants.download >>>', apiConstants.download);              
        api.get(apiConstants.download)
            .then((response) => {
              this.$vs.loading.close();
              if(response.data){
                let blob = new Blob([response.data],{ type:'text/csv'});
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'ProductLinksData-'+new Date().getTime()+'.csv';
                link.click();
                // this.csvJSON(response.data)
                // this.csvToJson(response.data)
              }
            })
            .catch((err) => {
            this.$vs.loading.close();
            console.log(err);
            error(getAxiosErrorMessage(err))
                this.$vs.notify({
                  title: "Error",
                  text: getAxiosErrorMessage(err),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
          }) 
      } catch(e) {
        this.$vs.loading.close();
      }      
      this.$vs.notify({color:'success',title:'Download Success',text:'File is downloaded successfully'});
    },
    submitData() {
      this.$validator.validateAll().then(result => {
          if (result) {
            const obj = {
              id: this.dataId,
              name: this.dataName,
              img: this.dataImg,
              category: this.dataCategory,
              order_status: this.dataOrder_status,
              price: this.dataPrice
            }

            if(this.dataId !== null && this.dataId >= 0) {
              this.$store.dispatch("dataList/updateItem", obj).catch(err => { console.error(err) })
            }else{
              delete obj.id
              obj.popularity = 0
              this.$store.dispatch("dataList/addItem", obj).catch(err => { console.error(err) })
            }

            this.$emit('closeSidebar')
            this.initValues()
          }
      })
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    successUpload(){
      this.$vs.notify({color:'success',title:'Upload Success',text:'File is uploaded successfully'});
    },
    handleFilePondInit: function () {
      console.log('FilePond has initialized');

      // example of instance method call on pond reference
      this.$refs.pond.getFiles();
    }
  },
  components: {
    VuePerfectScrollbar,
    VxTimeline,
    FilePond
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
